export default {
  apiKey: 'AIzaSyD3hvpcgyzHMjd4LXSyGBwXp_MY_g2Y9Rc',
  authDomain: 'hashimoto-f2154.firebaseapp.com',
  projectId: 'hashimoto-f2154',
  storageBucket: 'hashimoto-f2154.firebasestorage.app',
  messagingSenderId: '183840766189',
  appId: '1:183840766189:web:ec4c0108ec2b4454cfb4e4',
  measurementId: 'G-8NKHQRPDXP',
};
